import axios from 'axios';
import conso from '%/conso';


// s3
export const S3_API = '/asset'

// cmd routes

//auth and users
export const LOGIN = 'login';
export const REGISTER = 'register';
export const WHO_AM_I = 'who-am-i'
export const INIT_AUTH = 'init-auth';
export const LOGOUT_VIEW = 'logout-view';
export const UPDATE_CUSTOMER_INFO = 'update-customer-info';
export const GET_USER_ADDRESSES = 'get-user-addresses';
export const UPDATE_CREATE_ADDRESS = 'update-create-address';
export const UPDATE_TAX_CERTIFICATE = 'update-tax-certificate';
export const UPDATE_GOVERNMENT_CERTIFICATE = 'update-government-certificate';
export const UPDATE_OTHER_DOCUMENT = 'update-other-document';
export const UPLOAD_DOCUMENT_NOTIFICATION = 'upload-document-notification';


// products
export const PRODUCTS = 'products';
export const QUERY_PRODUCTS = 'query-products';
export const PRODUCTS_BY_CATEGORY = 'get-products-by-category';
export const FEATURED = 'featured';
export const CONTROL_REVIEWS = 'control-reviews';
export const ADD_PRODUCT_IMAGES = 'add-product-images';
export const ADD_PRODUCT_VIDEOS = 'add-product-videos';
export const DELETE_PRODUCT_IMAGES = 'delete-product-images';
export const GET_PRODUCT_ID = 'get-product-id';
export const GET_PICK_LIST_ID = 'get-pick-list-item-id';
export const GET_BRANDS = 'get-brands';
export const GET_CUSTOM_FIELD_DATA = 'get-custom-field-data';
export const GET_CUSTOM_FIELDS_ID = 'get-custom-fields-id';
export const INIT_INSTALLATIONS_DATA = 'init-installations-data';
export const INIT_TURNKEY_VEHICLES_DATA = 'init-turnkey-vehicles-data';


// categories
export const CATEGORIES = 'categories';
export const GET_CATEGORIES = 'get-categories';
export const GET_MANUFACTURERS = 'get-manufacturers';
export const GET_CATEGORY_TREE = 'get-category-tree';
export const CONTROL_BRANDS = 'control-brands';
export const POPULATE_CATEGORIES = 'populate-categories';

// cart / checkout
export const GET_CART = 'get-cart';
export const SET_CART = 'set-cart';
export const CONTROL_CART = 'control-cart';
export const GET_CART_ID = 'get-cart-id';
export const CAPTURE_TRANSACTION = 'capture-transaction';
export const GET_TAX_PREVIEW = 'get-tax-preview';
export const GIFT_CERTIFICATES = 'gift-certificates';
export const GET_ADD_ON_DETAILS = 'get-add-on-details';
export const GET_CUSTOMER_ORDERS = 'get-customer-orders';
export const APPLY_DISCOUNT = 'apply-discount';
export const FETCH_ADD_ONS = 'fetch-add-ons';
export const GET_ORDER_ID_CUSTOMER = 'get-order-id-customer';
export const HANDLE_CERTIFICATE = 'handle-certificate';
export const RETRIEVE_CERTIFICATES = 'retrieve-certificates';
export const CARDPOINTE_PROFILE = 'cardpointe-profile';
export const CREATE_CARDPOINTE_PROFILE = 'create-cardpointe-profile';
export const DELETE_CARDPOINTE_PROFILE = 'delete-cardpointe-profile';

// orders
export const CREATE_SHIPMENT = 'create-shipment';
export const GET_ORDER_REFUND_DATA = 'get-order-refund-data';
export const VERIFY_CERTIFICATE = 'verify-certificate';
export const EDIT_ORDER_NOTES = 'edit-order-notes';
export const GET_FAILED_ORDERS = 'get-failed-orders';

//shipping

export const DETERMINE_LOCATION = 'determine-location';
export const GET_SHIPPING_RATES = 'get-shipping-rates';
export const SHIP_WITH_WAREHOUSES = 'ship-with-warehouses';
export const CREATE_SHIPMENT_ITEM = 'create-shipment-item';
// contact form
export const CONTROL_CONTACT = 'control-contact';
export const VERIFY_RECAPTCHA = 'verify-token';
export const LOCATION_FORM = 'location-form';

// dashboard
export const GET_DASHBOARD = 'get-dashboard';
export const GET_CHART_DATA = 'get-chart-data';
export const EMPLOYEES = 'employees-control';
export const GET_REVENUE_REPORT = 'get-revenue-report';
export const PRODUCT_ACTIONS = 'product-actions';
export const GET_ORDER_ID = 'get-order-by-id';
export const GET_EMP_AUTH = 'get-emp-auth';
export const GET_OVERVIEW_ANALYTICS = 'get-overview-analytics';
export const EMP_LOGOUT_VIEW = 'employee-logout-view';
export const GET_ORDER_COUNTS = 'get-order-counts';
export const GET_ANALYTICS_PRODUCTS = 'get-analytics-products';
export const BULK_EDIT_CSV = 'bulk-csv-import';
export const MODIFY_SYSTEM_SETTINGS = 'modify-system-settings';
export const GET_SYSTEM_SETTINGS = 'get-system-settings';
export const ASSIGN_CUSTOMER_GROUP = 'assign-customer-group';
export const GET_REPORT_DATA = 'get-report-data';
export const SEO_CONTROL = 'seo-control';
export const EXPORT_PRODUCTS_URL = 'export-products-url';
export const CREATE_PRODUCTS_EXPORT = 'create-export-products';
export const GET_PRODUCT_IMAGES = 'get-product-images';
export const ADD_PRODUCT_VARIANTS = 'add-product-variants';
export const ADD_PRODUCT_CUSTOMIZATIONS = 'add-product-customizations';
export const FETCH_VARIANTS_OPTIONS = 'fetch-variants-options';
export const FETCH_CUSTOMIZATIONS = 'fetch-customizations';
export const DELETE_PRODUCT_ID = 'delete-product-id';
export const DELETE_CUSTOMIZATIONS = 'delete-customizations';
export const GET_SKU_PRICES = 'get-sku-prices';
export const DELETE_PRODUCT_OPTIONS = 'delete-product-options';
export const GET_CHANGELOG = 'get-changelog';
export const UPDATE_NOTIFICATION_SETTINGS = 'update-notification-settings';
export const REFUND_TRANSACTION = 'refund-transaction';
export const PARTIAL_REFUND_TRANSACTION = 'partial-refund-transaction';
export const REFUND_GIFT_CERTIFICATE = 'refund-gift-certificate';
export const DELETE_PRODUCT_MODIFIER = 'delete-product-modifier';
export const GET_MODIFIER_OPTIONS = 'get-modifier-options';
export const UPDATE_ORDER_STATUS = 'update-order-status';
export const UPDATE_ORDER_TRACKING_NUMBER = 'update-order-tracking-number';
export const GET_ORDER_TIMELINE = 'get-order-timeline';
export const LOAD_PRODUCT_REDIRECT = 'load-product-redirect';
export const POLL_CSV_FILE = 'poll-csv-file';
export const GET_CUSTOMER_ID = 'get-customer-id';
export const EDIT_CUSTOMER_ID = 'edit-customer-id';
export const DELETE_CUSTOMER_DOCUMENT = 'delete-customer-document';
export const EDIT_BRAND_ID = 'edit-brand-id';
export const DELETE_CUSTOMER = 'delete-customer';
export const CONTROL_TESTIMONIALS = 'control-testimonials';
export const ADD_PRODUCT_CUSTOM_FIELDS = 'add-product-custom-fields';
export const DELETE_PRODUCT_CUSTOM_FIELDS = 'delete-product-custom-fields';
export const CONTROL_UPLOAD_DOCUMENTS = 'control-upload-documents';
export const CONTROL_INSTALLATIONS = 'control-installations';
export const CONTROL_TURNKEYS = 'control-turnkeys';
export const CONTROL_TURNKEY_VEHICLES = 'control-turnkey-vehicles';
export const UPDATE_AM_SALES_ORDER_ID = 'update-am-sales-order-id';
export const CONTROL_LOCATIONS = 'control-locations';
export const CONTROL_TAXABLE_STATES_SETTINGS = 'control-taxable-states-settings';
export const HANDLE_OPTION_NAME_CHANGE = 'handle-option-name-change';
export const DEACTIVATE_AND_REDIRECT_API = 'deactivate-and-redirect-api';
export const CONTROL_LOCATION_MEMBERS = 'control-location-members';


// search
export const SEARCH = 'search';
export const SEARCH_WORDS = 'search-words';
export const SEARCH_OPTIONS = 'search-options';
export const SEARCH_FILTER = 'search-filter';
export const SEARCH_MULTIPLE_FILTERS = 'search-multiple-filter';
export const SEARCH_BRANDS = 'search-brands';
export const ADVANCED_SEARCH_ORDERS = 'advanced-search-orders';

// companies / groups
export const COMPANIES_CONTROL = 'companies-control';
export const CUSTOMERS_IN_GROUP = 'get-customers-in-group';
export const GROUPS_CONTROL = 'groups-control';


// user profile
export const GET_ACTIVITY_LOGS = 'get-activity-logs';
export const GET_ORDERS_USER = 'get-orders-by-user';
export const USER_CONTROL = 'user-control';
export const WRITE_NOTE = 'write-note';
export const SEARCH_CUSTOMERS = 'search-customers';
export const DELETE_ADDRESS = 'delete-address';
// discounts
export const CONTROL_DISCOUNT = 'control-discounts';
export const GET_CLOSEOUT_ID = 'get-closeout-id';
// blogs
export const CONTROL_BLOGS = 'control-blogs';

// SEO
export const SEO_LINKS = 'seo-links';

// const axios = Axios.create({
//   // baseURL: '/',
//   withCredentials: true,
//   withXSRFToken: true,
//   headers: {
//       "Content-Type": "application/json",
//       "Accept": "application/json",
//   },
// });

// success condition - returns true -> success | false -> fail
export const validateResponse = (json = {}) =>
  !(!json.data
    || json.msg
    || json.status === 'failure'
  ) || json.data === false || json.data === 0;


// axios request
// n is number of retries - default 1 | total number requests will be n + 1
const ax = async (cmd, payload = {}, headers = {}, n = 0) => {
  try {
    const res = await axios
      .post(`/api/dss?cmd=${cmd}`, {
        ...payload,
        cmd,
      },
        {
          headers: {
            ...headers,
            'X-CSRF-TOKEN': window.Laravel.csrfToken
          }
        }
      );
    if (!validateResponse(res.data)) {
      // if (n > 0) {
        // throw new Error()
        // return await ax(cmd, payload, headers, n - 1);
      // }
      if (process.env.MIX_APP_ENV === 'local')
        conso.trace(res.data)
      if (res.data.msg?.payment?.next_action?.use_stripe_sdk?.stripe_js) {
        return {
          nextAction: res.data.msg?.payment?.next_action?.use_stripe_sdk?.stripe_js
        };
      }else if(res.data.msg == 'Missing admin role') {
        alert('Request failed: invalid permissions');
      }

      throw new Error(res.data.msg)
    } else if (!res.data.data)
      return [];
    return res.data.data;
  } catch (er) {

    // retry request up to n times
    if (n > 0) {
      return await ax(cmd, payload, headers, n - 1);
    }
    throw new Error(er.message);
  }
}
export default ax;

export const stripeReq = async (cmd, payload = {}, headers = {}) => {
  try {
    const res = await axios
      .post('/api/dss', {
        ...payload,
        cmd,
      }, { headers });
    if (!validateResponse(res.data)) {
      if (process.env.MIX_APP_ENV === 'local')
        conso.trace(res.data)
      if (res.data.msg?.payment?.next_action?.use_stripe_sdk?.stripe_js) {
        return {
          nextAction: res.data.msg?.payment?.next_action?.use_stripe_sdk?.stripe_js
        };
      } 


      throw new Error(res.data.msg)
    }
    else if (res.data.data == {})
      return [];
    return res.data.data;
  } catch (er) {
    throw new Error(er.msg);
  }
}

export const needsStripeAction = (json) => {
  if (json.next_action) {

  }
  return false
}